import { atom } from "recoil";
import ProfilePic from "../../assets/img/avatar-img.png";
import { LEAD_FILTERS } from "../../helpers/LeadsScreen";
import { NotificationListRes } from "../../types";
export const deleteDocumentPopupState = atom({
    key: "deleteDocumentPopupState",
    default: false,
});

export const deleteUserPopupState = atom({
    key: "deleteUserPopupState",
    default: false,
});

export const deleteLeadsPopupState = atom({
    key: "deleteLeadsPopupState",
    default: false,
});
export const deleteOpportunitiesPopupState = atom({
    key: "deleteOpportunitiesPopupState",
    default: false,
});
export const deleteBusinessesPopupState = atom({
    key: "deleteBusinessesPopupState",
    default: false,
});
export const deleteClientsPopupState = atom({
    key: "deleteClientsPopupState",
    default: false,
});
export const deletePopup = atom({
    key: "deletePopup",
    default: "",
});
export const deletePopupCf = atom({
    key: "deletePopupCf",
    default: "",
});
export const deletePopupCpt = atom({
    key: "deletePopupCpt",
    default: "",
});
export const deletePopupCft = atom({
    key: "deletePopupCft",
    default: "",
});
export const deleteEmployeesPopupState = atom({
    key: "deleteEmployeesPopupState",
    default: false,
});

export const userPermissions = atom<string[]>({
    key: "userPermissions",
    default: [],
});

export const loadingAuth = atom({
    key: "loadingAuth",
    default: true,
});

export const userRoles = atom({
    key: "userRoles",
    default: [],
});

export const filterPopup = atom({
    key: "filterPopup",
    default: false,
});

export const auth0Id = atom({
    key: "auth0Id",
    default: "" as string,
});

export const userInfo = atom({
    key: "userInfo",
    default: { name: "", profile_image: ProfilePic, person_id: "" },
});
export const unreadNotifications = atom({
    key: "unreadNotifications",
    default: {} as NotificationListRes,
});
export const programsAtom = atom({
    key: "programsAtom",
    default: [],
});
export const recDocRowDeletePopup = atom({
    key: "documentRowDelete",
    default: { answered: false, showPopup: false, isLoading: false },
});
export const recAlreadyExistPopup = atom({
    key: "alreadyExistPopup",
    default: { showPopup: false, id: "", check: "" },
});

export const recRedFlagPopup = atom({
    key: "redFlagUpdate",
    default: { answered: false, showPopup: false, isLoading: false, note: "" },
});

export const recCheckmarkPopup = atom({
    key: "checkmarkUpdate",
    default: { answered: false, showPopup: false, isLoading: false, note: "" },
});

export const recDeleteLeadPopup = atom({
    key: "deleteLeadPopupState",
    default: { answered: false, showPopup: false, isLoading: false },
});
export const recDeleteCampaignPopup = atom({
    key: "recDeleteCampaignPopup",
    default: { answered: false, showPopup: false, isLoading: false },
});
export const recDeleteSettingPopup = atom({
    key: "recDeleteSettingPopup",
    default: { answered: false, showPopup: false, isLoading: false },
});

export const recDeleteClientPopup = atom({
    key: "recDeleteClientPopup",
    default: { answered: false, showPopup: false, isLoading: false },
});

export const recDeleteEmployeePopup = atom({
    key: "recDeleteEmployeePopup",
    default: { answered: false, showPopup: false, isLoading: false },
});

export const recAddToClientPopup = atom({
    key: "recAddToClientPopup",
    default: { answered: false, showPopup: false, isLoading: false },
});
export const leadPreFilters = atom({
    key: "leadPreFilters",
    default: {
        ...LEAD_FILTERS,
    },
});
export const contactPagination = atom({
    key: "contactPagination",
    default: {
        pageLimit: 10,
        page: 1,
        init: true,
    },
});
export const clientsSearchOptions = atom<any>({
    key: "clientsSearchOptions",
    default: undefined,
});
export const paymentsSearchOptions = atom<any>({
    key: "paymentsSearchOptions",
    default: undefined,
});
export const opportunitiesSearchOptions = atom<any>({
    key: "opportunitiesSearchOptions",
    default: undefined,
});
export const businessesSearchOptions = atom<any>({
    key: "businessesSearchOptions",
    default: undefined,
});
export const leadsSearchOptions = atom<any>({
    key: "leadsSearchOptions",
    default: undefined,
});
export const employeesSearchOptions = atom<any>({
    key: "employessSearchOptions",
    default: undefined,
});
export const conversationsSearchOptions = atom<any>({
    key: "conversationsSearchOptions",
    default: undefined,
});
export const campaignsSearchOptions = atom<any>({
    key: "campaignsSearchOptions",
    default: undefined,
});
export const usersSearchOptions = atom<any>({
    key: "usersSearchOptions",
    default: undefined,
});
export const programsToValidate = atom<any[]>({
    key: "realTimeProgramNotifications",
    default: []
})
export const openProgram = atom<any | null>({
    key: "openProgram",
    default: null
})
export const bulkConversationsSearchOptions = atom<any>({
    key: "bulkConversationsSearchOptions",
    default: undefined,
});
export const validatingProgram = atom<any>({
    key: "validatingProgramPopup",
    default: "",
});
export const addProgramPopup = atom<any>({
    key: "addProgramPopup",
    default: "",
});

type lastOpportunityRouteStateType = "Buyer & Seller" | "CR" | "Mortgage"| "HELOC";

export const lastOpportunityRouteState = atom<lastOpportunityRouteStateType>({
    key: "lastOpportunityRouteState",
    default: "Buyer & Seller",
});
